<template>

	<div class="container">
		<div class="row outer-frame">

			<div class="col-xs-12 mv10 f15">
				<a class="black" @click.stop.prevent="topic.click()">首页</a>
				<a class="black" v-if="topic.activeModuleMenu && topic.activeChildMenu" @click.stop.prevent="topic.activeModuleMenu.click()">
					/ {{topic.activeModuleMenu.name}}
				</a>
				<span v-if="topic.activeModuleMenu && !topic.activeChildMenu">/ {{topic.activeModuleMenu.name}}</span>
				<span v-if="topic.activeChildMenu">/ {{topic.activeChildMenu.name}}</span>
			</div>

			<div class="col-md-3">
				<div v-if="topic.activeModuleMenu && topic.activeModuleMenu.menus">
					<div  v-for="menu in topic.activeModuleMenu.menus">
						<div class="menu-item" :class="{'active': topic.activeChildMenu && topic.activeChildMenu.location === menu.location}"
						     @click.stop.prevent="$router.push(menu.getUrl())">
								{{menu.name}}
						</div>
						<div></div>
					</div>
				</div>

			</div>
			<div class="col-md-9 bg-white mb40">

				<slot></slot>
			</div>
		</div>

	</div>

</template>

<script>
	import ArticleView from "./widget/ArticleView"
	import Article from "../../../common/model/article/Article";
	export default {
		data () {
			return {}
		},
		computed: {
			topic(){
				return this.$route.meta.topic;
			}
		},
		components: {},
		watch: {},
		methods: {},
		mounted(){
		}
	}

</script>

<style lang="less" rel="stylesheet/less">
	@import "../../../common/assets/css/global/variables";

	.outer-frame {

		.menu-item {
			border-bottom: 1px solid #ddd;
			line-height: 32px;
			cursor: pointer;

			&.active {
				font-weight: 700;
				color: #0074d9;
			}
		}

	}

</style>




// WEBPACK FOOTER //
// Outer.vue?692a27c9